import _ from 'lodash';
import { v4 as UUID } from 'uuid';
import BaseBuilder from './BaseBuilder';
import SectionBuilder from './SectionBuilder';
export default class BlueprintBuilder extends BaseBuilder {
    seedProviders;
    blueprint;
    constructor(seedProviders) {
        super();
        this.seedProviders = seedProviders;
        this.blueprint = {
            sectionBlueprints: [],
            sectionGroupBlueprints: {
                insuredPeople: {
                    id: UUID(),
                    partName: 'insuredPeople',
                    title: { en: 'SectionGroup Title', fr: 'Titre du groupe de sections' },
                    repeatable: { minRepeatable: 1, maxRepeatable: 6, repeatableAnswerNodeId: 'insured-people' },
                },
                contract: { id: UUID(), partName: 'contract' },
            },
        };
    }
    withSectionGroups(sectionGroupBuilders) {
        if (!sectionGroupBuilders) {
            return this;
        }
        delete this.blueprint.sectionGroupBlueprints.contract;
        delete this.blueprint.sectionGroupBlueprints.insuredPeople;
        if (Array.isArray(sectionGroupBuilders)) {
            for (const sectionGroupBuilder of sectionGroupBuilders) {
                const key = sectionGroupBuilder.getSectionGroupKey();
                if (key) {
                    const sectionGroup = sectionGroupBuilder.build();
                    this.blueprint.sectionGroupBlueprints[key] = sectionGroup;
                }
            }
        }
        else {
            const key = sectionGroupBuilders.getSectionGroupKey();
            if (key) {
                const sectionGroup = sectionGroupBuilders.build();
                this.blueprint.sectionGroupBlueprints[key] = sectionGroup;
            }
        }
        return this.clone();
    }
    withSections(sectionBuilders) {
        if (!sectionBuilders) {
            return this;
        }
        if (Array.isArray(sectionBuilders)) {
            const builtSections = [];
            for (const sectionBuilder of sectionBuilders) {
                builtSections.push(sectionBuilder.build());
            }
            this.blueprint.sectionBlueprints = this.blueprint.sectionBlueprints.concat(builtSections);
        }
        else {
            this.blueprint.sectionBlueprints.push(sectionBuilders.build());
        }
        return this.clone();
    }
    withSubsections(subsectionBuilders) {
        this.blueprint.sectionBlueprints.push(this.childBuilder().withSubsections(subsectionBuilders).build());
        return this.clone();
    }
    withFieldGroups(fieldGroupBuilders) {
        this.blueprint.sectionBlueprints.push(this.childBuilder().withFieldGroups(fieldGroupBuilders).build());
        return this.clone();
    }
    withFields(fieldBuilders) {
        this.blueprint.sectionBlueprints.push(this.childBuilder().withFields(fieldBuilders).build());
        return this.clone();
    }
    build() {
        return _.cloneDeep(this.blueprint);
    }
    childBuilder() {
        return new SectionBuilder(this.seedProviders);
    }
}
